// React
import React from 'react';
// Material ui
import { Grid, Slide, Typography } from '@material-ui/core';
import { useGroupStyle } from './group.style';
/**
 * Group component
 * @param props
 */
var Group = function (_a) {
    var children = _a.children, description = _a.description, title = _a.title, stepper = _a.stepper, currentStep = _a.currentStep, groupStep = _a.groupStep, nextButton = _a.nextButton;
    /** Component states */
    var _b = React.useState('right'), direction = _b[0], setDirection = _b[1];
    // Component step effect
    React.useEffect(function () {
        if (currentStep > groupStep) {
            setDirection('left');
        }
        else {
            setDirection('right');
        }
    }, [currentStep, groupStep]);
    /** Component classes */
    var classes = useGroupStyle();
    /** Component core content */
    var content = React.createElement(Grid, { className: stepper ? classes.content : undefined, container: true, justify: 'center', direction: 'column' },
        title && React.createElement(Grid, { item: true },
            React.createElement(Typography, { align: 'center', variant: 'h2' }, title)),
        description && React.createElement(Grid, { item: true },
            React.createElement(Typography, { align: 'center', variant: 'body1' }, description)),
        React.createElement(Grid, { item: true, container: true, direction: 'column' }, children),
        nextButton);
    if (stepper) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Slide, { direction: currentStep <= groupStep && direction === 'right' ? 'left' : 'right', in: currentStep === groupStep }, content)));
    }
    return content;
};
export default Group;
//# sourceMappingURL=index.js.map